/**
 * @typedef {Object} NavLinkItem
 * @property {string} to    Route path.
 * @property {string} label Text shown in the header and footer navigation.
 */

/** @type {NavLinkItem[]} */
export const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/About', label: 'About Us' },
  { to: '/Service', label: 'Our Services' },
  { to: '/Team', label: 'Our Staff' },
  { to: '/Locations', label: 'Locations' },
  { to: '/Product', label: 'Our Products' },
];
